// Generated by CoffeeScript 2.3.2
(function() {
  var Enum, List, Optional, Primitive, Reader, Scaled, Struct, Type, Utf8String, VarInt, Writer, bitMask, bitsNeeded, bytesBitsNeeded, popCount, scale, stringToUtf8, utf8toString, varint, varuint;

  scale = function(v, vmin, vmax, min, max) {
    return (v - vmin) / (vmax - vmin) * (max - min) + min;
  };

  stringToUtf8 = function(s) {
    return new Uint8Array(unescape(encodeURIComponent(s)).split('').map(function(c) {
      return c.charCodeAt(0);
    }));
  };

  utf8toString = function(b) {
    return decodeURIComponent(escape(String.fromCharCode.apply(null, b)));
  };

  popCount = function(bits) {
    bits -= (bits >> 1) & 0x55555555;
    bits = (bits & 0x33333333) + ((bits >> 2) & 0x33333333);
    return (((bits + (bits >> 4)) & 0x0f0f0f0f) * 0x01010101) >> 24;
  };

  bitMask = function(bits) {
    bits |= bits >> 1;
    bits |= bits >> 2;
    bits |= bits >> 4;
    bits |= bits >> 8;
    return bits |= bits >> 16;
  };

  bitsNeeded = function(v) {
    return popCount(bitMask(v));
  };

  Reader = class Reader {
    constructor(buf) {
      this.data = new Uint8Array(buf);
      this.view = new DataView(buf);
      this.cur = 0;
    }

    bytesLeft() {
      return this.data.length - this.cur;
    }

    resetBits() {
      return delete this.bitsLeft;
    }

    readBits(count) {
      var bitsToRead, mask, pos, result;
      result = 0;
      pos = 0;
      while (count) {
        if (!this.bitsLeft) {
          this.bits = this.u8();
          this.bitsLeft = 8;
        }
        bitsToRead = Math.min(this.bitsLeft, count);
        mask = (1 << bitsToRead) - 1;
        result |= (mask & this.bits) << pos;
        pos += bitsToRead;
        count -= bitsToRead;
        this.bitsLeft -= bitsToRead;
        this.bits >>= bitsToRead;
      }
      return result;
    }

    i1() {
      return Boolean(this.readBits(1));
    }

    u8() {
      return this.view.getUint8(this.cur++);
    }

    u16() {
      return this.view.getUint16((this.cur += 2) - 2, true);
    }

    u32() {
      return this.view.getUint32((this.cur += 4) - 4, true);
    }

    i8() {
      return this.view.getInt8(this.cur++);
    }

    i16() {
      return this.view.getInt16((this.cur += 2) - 2, true);
    }

    i32() {
      return this.view.getInt32((this.cur += 4) - 4, true);
    }

    f32() {
      return this.view.getFloat32((this.cur += 4) - 4, true);
    }

    buf(len) {
      return this.data.subarray(this.cur, this.cur += len);
    }

  };

  Writer = class Writer {
    constructor(sz) {
      this.data = new Uint8Array(sz);
      this.view = new DataView(this.data.buffer);
      this.end = 0;
    }

    writeBits(bits, count) {
      var bitsToWrite, mask, results;
      results = [];
      while (count) {
        if (!this.bitsLeft) {
          this.bitsPos = this.end;
          this.u8(0);
          this.bitsLeft = 8;
        }
        bitsToWrite = Math.min(this.bitsLeft, count);
        mask = (1 << bitsToWrite) - 1;
        this.data[this.bitsPos] |= (mask & bits) << (8 - this.bitsLeft);
        this.bitsLeft -= bitsToWrite;
        count -= bitsToWrite;
        results.push(bits >>= bitsToWrite);
      }
      return results;
    }

    i1(v) {
      return this.writeBits(v, 1);
    }

    u8(v) {
      return this.view.setUint8(this.end++, v);
    }

    u16(v) {
      return this.view.setUint16((this.end += 2) - 2, v, true);
    }

    u32(v) {
      return this.view.setUint32((this.end += 4) - 4, v, true);
    }

    i8(v) {
      return this.view.setInt8(this.end++, v);
    }

    i16(v) {
      return this.view.setInt16((this.end += 2) - 2, v, true);
    }

    i32(v) {
      return this.view.setInt32((this.end += 4) - 4, v, true);
    }

    f32(v) {
      return this.view.setFloat32((this.end += 4) - 4, v, true);
    }

    buf(v) {
      this.data.set(v, this.end);
      return this.end += v.length;
    }

    content() {
      return this.data.buffer.slice(0, this.end);
    }

  };

  Type = class Type {
    byteLength(v) {
      return Math.floor((7 + this.bitLength(v)) / 8);
    }

    unpack(buf) {
      return this.unpackFrom(new Reader(buf));
    }

    pack(v) {
      var w;
      w = new Writer(this.byteLength(v));
      this.packInto(w, v);
      return w.data.buffer;
    }

  };

  Primitive = class Primitive extends Type {
    constructor(t, bits1, min1, max1) {
      super();
      this.t = t;
      this.bits = bits1;
      this.min = min1;
      this.max = max1;
      this.t += this.bits;
    }

    create() {
      return 0;
    }

    bitLength() {
      return this.bits;
    }

    unpackFrom(r) {
      return r[this.t]();
    }

    packInto(w, v) {
      return w[this.t](v);
    }

  };

  bytesBitsNeeded = function(v) {
    if (v <= 0xffff) {
      if (v <= 0xff) {
        return 0;
      } else {
        return 1;
      }
    } else {
      if (v <= 0xffffffff) {
        return 2;
      } else {
        return 3;
      }
    }
  };

  VarInt = class VarInt extends Type {
    constructor(format) {
      super();
      this.format = format;
    }

    bitLength(v) {
      return 2 + 8 * (1 << bytesBitsNeeded(v));
    }

    unpackFrom(r) {
      var bb;
      bb = r.readBits(2);
      if (bb === 3) {
        throw new RangeError('Length over 0xffffffff is not supported for JS');
      }
      return r[this.format[bb]]();
    }

    packInto(w, v) {
      var bb;
      bb = bytesBitsNeeded(v);
      if (bb === 3) {
        throw new RangeError('Length over 0xffffffff is not supported for JS');
      }
      w.writeBits(bb, 2);
      return w[this.format[bb]](v);
    }

  };

  varint = new VarInt(['i8', 'i16', 'i32']);

  varuint = new VarInt(['u8', 'u16', 'u32']);

  Utf8String = class Utf8String extends Type {
    create() {
      return '';
    }

    bitLength(v) {
      var l;
      l = stringToUtf8(v).length;
      return varuint.bitLength(l) + 8 * l;
    }

    unpackFrom(r) {
      var l;
      l = varuint.unpackFrom(r);
      return utf8toString(r.buf(l));
    }

    packInto(w, v) {
      var b;
      b = stringToUtf8(v);
      varuint.packInto(w, b.length);
      return w.buf(b);
    }

  };

  Scaled = class Scaled extends Type {
    constructor(type1, min1, max1) {
      super();
      this.type = type1;
      this.min = min1;
      this.max = max1;
    }

    create() {
      return this.min;
    }

    bitLength() {
      return this.type.bits;
    }

    unpackFrom(r) {
      return scale(this.type.unpackFrom(r), this.type.min, this.type.max, this.min, this.max);
    }

    packInto(w, v) {
      return this.type.packInto(w, scale(v, this.min, this.max, this.type.min, this.type.max));
    }

  };

  Enum = class Enum extends Type {
    constructor(members1) {
      var i, j, len1, name, ref;
      super();
      this.members = members1;
      this.index = {};
      ref = this.members;
      for (i = j = 0, len1 = ref.length; j < len1; i = ++j) {
        name = ref[i];
        this.index[name] = i;
      }
      this.bits = bitsNeeded(this.members.length - 1);
    }

    create() {
      return this.members[0];
    }

    bitLength() {
      return this.bits;
    }

    unpackFrom(r) {
      return this.members[r.readBits(this.bits)];
    }

    packInto(w, v) {
      var i;
      i = this.index[v];
      if (i != null) {
        return w.writeBits(i, this.bits);
      } else {
        throw new Error(`Unknown enum value ${v}`);
      }
    }

  };

  Optional = class Optional extends Type {
    constructor(type1) {
      super();
      this.type = type1;
    }

    bitLength(v) {
      if (v != null) {
        return 1 + this.type.bitLength(v);
      } else {
        return 1;
      }
    }

    unpackFrom(r) {
      if (r.i1()) {
        return this.type.unpackFrom(r);
      }
    }

    packInto(w, v) {
      w.i1(v != null);
      if (v != null) {
        return this.type.packInto(w, v);
      }
    }

  };

  List = class List extends Type {
    constructor(type1) {
      super();
      this.type = type1;
    }

    create() {
      return [];
    }

    bitLength(v) {
      var j, len1, s, x;
      s = varuint.bitLength(v.length);
      for (j = 0, len1 = v.length; j < len1; j++) {
        x = v[j];
        s += this.type.bitLength(x);
      }
      return s;
    }

    unpackFrom(r) {
      var i, j, l, ref, results;
      l = varuint.unpackFrom(r);
      results = [];
      for (i = j = 0, ref = l; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        results.push(this.type.unpackFrom(r));
      }
      return results;
    }

    packInto(w, v) {
      var j, len1, results, x;
      varuint.packInto(w, v.length);
      results = [];
      for (j = 0, len1 = v.length; j < len1; j++) {
        x = v[j];
        results.push(this.type.packInto(w, x));
      }
      return results;
    }

  };

  Struct = class Struct extends Type {
    constructor(members1) {
      super();
      this.members = members1;
    }

    create() {
      var j, len1, name, ref, result, type, value;
      result = {};
      ref = this.members;
      for (j = 0, len1 = ref.length; j < len1; j++) {
        [name, type, value] = ref[j];
        result[name] = value != null ? value : typeof type.create === "function" ? type.create() : void 0;
      }
      return result;
    }

    bitLength(v) {
      var j, len1, name, ref, s, type;
      s = 0;
      ref = this.members;
      for (j = 0, len1 = ref.length; j < len1; j++) {
        [name, type] = ref[j];
        s += type.bitLength(v[name]);
      }
      return s;
    }

    unpackFrom(r) {
      var j, len1, name, ref, result, type, v;
      result = {};
      ref = this.members;
      for (j = 0, len1 = ref.length; j < len1; j++) {
        [name, type] = ref[j];
        v = type.unpackFrom(r);
        if (v != null) {
          result[name] = v;
        }
      }
      return result;
    }

    packInto(w, value) {
      var j, len1, name, ref, results, type;
      ref = this.members;
      results = [];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        [name, type] = ref[j];
        results.push(type.packInto(w, value[name]));
      }
      return results;
    }

  };

  module.exports = {
    bool: new Primitive('i', 1, 0, 1),
    int8: new Primitive('i', 8, -0x80, 0x7f),
    int16: new Primitive('i', 16, -0x8000, 0x7fff),
    int32: new Primitive('i', 32, -0x80000000, 0x7fffffff),
    uint8: new Primitive('u', 8, 0, 0xff),
    uint16: new Primitive('u', 16, 0, 0xffff),
    uint32: new Primitive('u', 32, 0, 0xffffffff),
    float32: new Primitive('f', 32, -3.40282347e+38, 3.40282347e+38),
    string: new Utf8String,
    scaled: function(type, min, max) {
      return new Scaled(type, min, max);
    },
    enum: function(members) {
      return new Enum(members);
    },
    optional: function(type) {
      return new Optional(type);
    },
    list: function(type) {
      return new List(type);
    },
    struct: function(members) {
      var key, value;
      return new Struct((function() {
        var results;
        if (members instanceof Array) {
          return members;
        } else {
          results = [];
          for (key in members) {
            value = members[key];
            if (value instanceof Array) {
              results.push([key, value[0], value[1]]);
            } else {
              results.push([key, value]);
            }
          }
          return results;
        }
      })());
    },
    Scaled: Scaled,
    Enum: Enum,
    Optional: Optional,
    List: List,
    Struct: Struct,
    Reader: Reader,
    Writer: Writer
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./server/wsgame/binary-wheel/index.js
// module id = 4
// module chunks = 0